/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SoftcoverInputs */

const en_softcover = /** @type {(inputs: SoftcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softcover`)
};

const es_softcover = /** @type {(inputs: SoftcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapa blanda`)
};

const fr_softcover = /** @type {(inputs: SoftcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couverture souple`)
};

const de_softcover = /** @type {(inputs: SoftcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softcover`)
};

const ja_softcover = /** @type {(inputs: SoftcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソフトカバー`)
};

const zh_softcover = /** @type {(inputs: SoftcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平装版`)
};

const ar_softcover = /** @type {(inputs: SoftcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غلاف ورقي`)
};

const id_softcover = /** @type {(inputs: SoftcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sampul Lunak`)
};

const it_softcover = /** @type {(inputs: SoftcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copertina Flessibile`)
};

const ru_softcover = /** @type {(inputs: SoftcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мягкая Обложка`)
};

const pt_softcover = /** @type {(inputs: SoftcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capa Mole`)
};

const ko_softcover = /** @type {(inputs: SoftcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소프트커버`)
};

/**
* | output |
* | --- |
* | "Softcover" |
*
* @param {SoftcoverInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const softcover = /** @type {((inputs?: SoftcoverInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SoftcoverInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_softcover(inputs)
	if (locale === "es") return es_softcover(inputs)
	if (locale === "fr") return fr_softcover(inputs)
	if (locale === "de") return de_softcover(inputs)
	if (locale === "ja") return ja_softcover(inputs)
	if (locale === "zh") return zh_softcover(inputs)
	if (locale === "ar") return ar_softcover(inputs)
	if (locale === "id") return id_softcover(inputs)
	if (locale === "it") return it_softcover(inputs)
	if (locale === "ru") return ru_softcover(inputs)
	if (locale === "pt") return pt_softcover(inputs)
	return ko_softcover(inputs)
});